import React from 'react';
import { useTranslation } from 'react-i18next';
import { Crown, CalendarDays, BadgeCheck, Timer } from 'lucide-react';
import { PremiumWindow } from '../../../api/premiumService';

interface Props {
  premium: PremiumWindow;
}

const PremiumBanner: React.FC<Props> = ({ premium }) => {
  const { t } = useTranslation();
  const until = new Date(premium.ends_at);
  const daysLeft = premium.days_left;

  const formatDate = (d: Date) =>
    d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' });

  return (
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 p-8 text-white shadow-lg">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15">
            <Crown className="h-6 w-6" />
          </span>
          <div>
            <h1 className="text-2xl font-extrabold">{t('premium.title_active')}</h1>
            <p className="text-white/80">{t('premium.subtitle_active')}</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-sm backdrop-blur">
            <BadgeCheck className="h-4 w-4" /> {t('premium.badge')}
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-sm backdrop-blur">
            <CalendarDays className="h-4 w-4" /> {t('premium.until')}: {formatDate(until)}
          </span>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-sm backdrop-blur">
            <Timer className="h-4 w-4" /> {t('premium.days_left', { count: daysLeft })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PremiumBanner;
